/**
 * Status codes returned by the import API (machine-readable, not translated)
 */
export const STATUS_CODES = {
  // Polling status
  IN_PROGRESS: 'in_progress',
  FINISHED: 'finished',
  FINISHED_WITH_ERRORS: 'finished_with_errors',
  FAILED: 'failed',
  // Result status
  CREATED: 'created',
  UPDATED: 'updated',
  CACHED: 'cached',
  DELETED: 'deleted',
  ERROR: 'error',
};
/**
 * Possible warning types after an import
 */
export const WARNING_TYPES = {
  CODE_CHANGE: 'code_change',
};
/**
 * Available actions for the reducer
 */
export const IMPORT_ACTIONS = {
  SET_STATUS: 'SET_STATUS',
  SET_JOB_ID: 'SET_JOB_ID',
  SET_RESULT: 'SET_RESULT',
  SET_IMPORT_CONFIG: 'SET_IMPORT_CONFIG', // To set importFrom, importType, etc. all at once
  SET_GEOFOLIA_STEP: 'SET_GEOFOLIA_STEP',
  OPEN_CODE_CHANGE_MODAL: 'OPEN_CODE_CHANGE_MODAL',
  CLOSE_CODE_CHANGE_MODAL: 'CLOSE_CODE_CHANGE_MODAL',
  SET_MESSAGE_TO_DISPLAY: 'SET_MESSAGE_TO_DISPLAY',
  RESET: 'RESET',
};
/**
 * Initial state of the import context
 */
export const INITIAL_STATE = {
  // Import job state
  status: null,
  jobId: null,
  result: null,
  // Current import configuration
  importFrom: null, // IMPORT_FROM.classic or IMPORT_FROM.procedure
  importType: null, // IMPORT_TYPE.telepac, csv, geofolia, wiuz
  importOriginLocation: null,
  nextCampaignChosen: null,
  // Geofolia specific state (2-step import)
  geofoliaImportSteps: 0,
  // UI
  isOpenChangeCodeModal: false,
  messageToDisplayInResult: null,
};
/**
 * Helper to extract the statusCode from the API response (machine-readable, for navigation logic)
 */
export const getResultStatusCode = (result) => {
  return result?.message?.exploitations?.[0]?.statusCode || null;
};
/**
 * Helper to extract the warning from the API response
 */
export const getWarningFromResult = (result) => {
  return result?.message?.exploitations?.[0]?.warning || null;
};
/**
 * Helper to check if it's a code change
 */
export const isCodeChangeWarning = (result) => {
  const warning = getWarningFromResult(result);
  return warning?.type === WARNING_TYPES.CODE_CHANGE;
};
